import React, { FunctionComponent } from 'react';
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select, SelectChangeEvent } from '@mui/material';

import { SnapSettings } from '@paragon/contract-library';

interface Props {
  value: SnapSettings;
  onChange: (value: SnapSettings) => void;
}

export const SnapSettingsSelect: FunctionComponent<Props> = (props) => {
  const showMidLineSnapsCheckBox = (
    <MenuItem value="midline" className="midlineSnaps">
      <Checkbox color="default" checked={props.value.showMidLineSnaps} />
      <ListItemText primary="Midline Snaps" />
    </MenuItem>
  );

  const showCentroidSnapsCheckBox = (
    <MenuItem value="centroid" className="centroidSnaps">
      <Checkbox color="default" checked={props.value.showCentroidSnaps} />
      <ListItemText primary="Centroid Snaps" />
    </MenuItem>
  );

  const showIntersectionsSnapsCheckBox = (
    <MenuItem value="intersection" className="intersectionSnaps">
      <Checkbox color="default" checked={props.value.showIntersectionSnaps} />
      <ListItemText primary="Intersection Snaps" />
    </MenuItem>
  );

  const showVerticesSnapsCheckBox = (
    <MenuItem value="vertex" className="vertexSnaps">
      <Checkbox color="default" checked={props.value.showVertexSnaps} />
      <ListItemText primary="Vertex Snaps" />
    </MenuItem>
  );

  const enabledSnaps: string[] = [];
  if (props.value.showMidLineSnaps) enabledSnaps.push('midline');
  if (props.value.showCentroidSnaps) enabledSnaps.push('centroid');
  if (props.value.showVertexSnaps) enabledSnaps.push('vertex');
  if (props.value.showIntersectionSnaps) enabledSnaps.push('intersection');

  const getSnapsText = (snaps: unknown) => ((snaps as string[]).length === 4 ? 'All Snaps' : 'Custom...');

  const onSnapsChange = (event: SelectChangeEvent<string[]>) => {
    const selectedSnaps = event.target.value as string[];

    props.onChange({
      showMidLineSnaps: selectedSnaps.includes('midline'),
      showCentroidSnaps: selectedSnaps.includes('centroid'),
      showVertexSnaps: selectedSnaps.includes('vertex'),
      showIntersectionSnaps: selectedSnaps.includes('intersection'),
    });
  };

  return (
    <FormControl margin="normal" variant="standard">
      <InputLabel htmlFor="dimension-snaps">Dimension Snaps</InputLabel>
      <Select
        multiple
        value={enabledSnaps}
        renderValue={getSnapsText}
        onChange={onSnapsChange}
        inputProps={{
          id: 'dimension-snaps',
        }}
        label="Dimension Snaps"
      >
        {showMidLineSnapsCheckBox}
        {showCentroidSnapsCheckBox}
        {showIntersectionsSnapsCheckBox}
        {showVerticesSnapsCheckBox}
      </Select>
    </FormControl>
  );
};
